import * as React from 'react';
import { NavLink, RouteComponentProps } from 'react-router-dom';
import { Menu } from 'semantic-ui-react';

type Props = RouteComponentProps;

const MenuDeudores: React.FunctionComponent<Props> = props => {
    const rutaBase = props.match.url;

    return (
        <Menu tabular>
            <Menu.Item as={NavLink} exact to={rutaBase + '/cuotas'} content='Cuotas' />
            <Menu.Item
                as={NavLink}
                exact
                to={rutaBase + '/otros-cobros'}
                content='Gastos notariales y abonos iniciales'
            />
        </Menu>
    );
};

export default MenuDeudores;



// WEBPACK FOOTER //
// ./src/modulos/Cobranzas/componentes/Deudores/MenuDeudores.tsx